if (!customElements.get('quick-comparison-table')) {
  customElements.define(
    'quick-comparison-table',
    class QuickComparisonTable extends HTMLElement {
      constructor() {
        super();

        this.isEditorMode = this.checkEditorMode();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }

        this.bindEditorEvents();
      }

      checkEditorMode() {
        return (
          window.Shopify && 
          window.Shopify.designMode === true
        ) || 
        window.location.search.includes('preview_theme_id') ||
        document.body.classList.contains('shopify-design-mode') ||
        window.parent !== window;
      }

      bindEditorEvents() {
        document.addEventListener('shopify:section:load', (event) => {
          const sectionElement = event.target;
          if (sectionElement && sectionElement.querySelector('quick-comparison-table')) {
            setTimeout(() => {
              this.init();
            }, 100);
          }
        });

        document.addEventListener('shopify:section:unload', (event) => {
          const sectionElement = event.target;
          if (sectionElement && sectionElement.querySelector('quick-comparison-table')) {
            this.cleanup();
          }
        });

        document.addEventListener('shopify:section:reorder', (event) => {
          const sectionElement = event.target;
          if (sectionElement && sectionElement.querySelector('quick-comparison-table')) {
            setTimeout(() => {
              this.init();
            }, 100);
          }
        });
      }

      init() {
        if (this.hasAttribute('data-initialized')) {
          return;
        }

        if (this.isEditorMode && !this.dataset.url) {
          return;
        }

        if (!this.dataset.url) {
          console.warn('QuickComparisonTable: No URL provided');
          return;
        }

        this.showLoadingState();

                fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            const recommendations = sectionInnerHTML.querySelector('quick-comparison-table');
            
            if (recommendations && recommendations.innerHTML.trim().length) {
              const hasActualTable = recommendations.querySelector('table.quick-comparison-table');
              const hasContainer = recommendations.querySelector('.quick-comparison-table-container');
              
              this.hideLoadingState();
              this.innerHTML = recommendations.innerHTML;
              this.setAttribute('data-initialized', 'true');
              
              if (hasActualTable && hasContainer) {
                this.dispatchEvent(new CustomEvent('quick-comparison-table:loaded'));
                
                setTimeout(() => {
                  const containers = this.querySelectorAll('.quick-comparison-table-container');
                  
                  let container = null;
                  for (const cont of containers) {
                    const hasTable = cont.querySelector('table.quick-comparison-table');
                    const hasSkeleton = cont.querySelector('.quick-comparison-table-skeleton');
                    
                    if (hasTable && !hasSkeleton) {
                      container = cont;
                      break;
                    }
                  }
                  
                  const table = this.querySelector('table.quick-comparison-table');
                  
                  if (container && table) {
                    initSwiper(container);
                  }
                }, 300);
                
              } else if (hasContainer) {
                this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
                setTimeout(() => {
                  const section = this.closest('.shopify-section');
                  if (section) {
                    section.remove();
                  }
                }, 500);
                
              } else {
                this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
                const section = this.closest('.shopify-section');
                if (section) {
                  section.remove();
                }
              }
            } else {
              this.hideLoadingState();
              const section = this.closest('.shopify-section');
              if (section) {
                section.remove();
              }
              this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
            }
          })
          .catch((e) => {
            this.hideLoadingState();
            console.error('QuickComparisonTable: Failed to load', e);
          });
      }

      showLoadingState() {
        const loadingElement = this.querySelector('.quick-comparison-table-loading');
        if (loadingElement) {
          loadingElement.classList.remove('hidden');
        }
      }

      hideLoadingState() {
        const loadingElement = this.querySelector('.quick-comparison-table-loading');
        if (loadingElement) {
          loadingElement.remove();
        }
      }

      cleanup() {
        this.removeAttribute('data-initialized');
        
        const placeholder = this.querySelector('.quick-comparison-table-editor-placeholder');
        if (placeholder) {
          placeholder.remove();
        }
        
        const container = this.querySelector('.quick-comparison-table-container');
        if (container) {
          container.removeEventListener('touchstart', this.handleStart);
          container.removeEventListener('touchmove', this.handleMove);
          container.removeEventListener('touchend', this.handleEnd);
          
          container.removeEventListener('mousedown', this.handleStart);
          container.removeEventListener('mousemove', this.handleMove);
          container.removeEventListener('mouseup', this.handleEnd);
          container.removeEventListener('contextmenu', this.handleContextMenu);
        }
      }

      refresh() {
        this.removeAttribute('data-initialized');
        this.innerHTML = '';
        this.init();
      }
    }
  );
}

function initSwiper(container) {
  initSwiperLogic(container);
  
  const swipeIndicator = container.querySelector('.swipe-indicator-mobile');
  const table = container.querySelector('table.quick-comparison-table');
  
  if (!swipeIndicator || !table) {
    return;
  }
  
  const isMobile = window.innerWidth <= 767;
    
  if (!isMobile) {
    swipeIndicator.style.display = 'none';
    return;
  }
  
  swipeIndicator.style.opacity = '0';
  swipeIndicator.style.display = 'none';
  
  let isIndicatorReady = false;
  
  const showSwipeIndicator = (retryCount = 0) => {
    swipeIndicator.style.opacity = '0';
    swipeIndicator.style.display = 'flex';
    
    const allRows = table.querySelectorAll('tr');
    if (allRows.length === 0) {
      if (retryCount < 5) {
        setTimeout(() => showSwipeIndicator(retryCount + 1), 200);
      }
      return;
    }
    
    const firstRow = allRows[0];
    const allColumns = firstRow.querySelectorAll('td');
    const targetColumn = allColumns[2]; // Third column = First recommendation
    
    if (!targetColumn || allColumns.length < 3) {
      if (retryCount < 5) {
        setTimeout(() => showSwipeIndicator(retryCount + 1), 300);
      }
      return;
    }
    
    const contentRows = Array.from(allRows).slice(2);
    if (contentRows.length === 0) {
      if (retryCount < 5) {
        setTimeout(() => showSwipeIndicator(retryCount + 1), 300);
      }
      return;
    }
    
    const middleIndex = Math.floor(contentRows.length / 2);
    const targetRow = contentRows[middleIndex];
    
    const containerRect = container.getBoundingClientRect();
    const columnRect = targetColumn.getBoundingClientRect();
    const rowRect = targetRow.getBoundingClientRect();
    
    const left = columnRect.left - containerRect.left + (columnRect.width / 2);
    const top = rowRect.top - containerRect.top + (rowRect.height / 2);
    
    swipeIndicator.style.position = 'absolute';
    swipeIndicator.style.left = left + 'px';
    swipeIndicator.style.top = top + 'px';
    swipeIndicator.style.transform = 'translate(-50%, -50%)';
    swipeIndicator.style.transition = 'opacity 0.3s ease-in';
    
    const handIcon = swipeIndicator.querySelector('.hand-icon');
    if (handIcon) {
      handIcon.style.animation = 'swipeLeft 2s ease-in-out infinite';
    }
    
    isIndicatorReady = true;
    setTimeout(() => {
      swipeIndicator.style.opacity = '1';
    }, 50);
    
    setTimeout(() => {
      hideSwipeIndicator();
    }, 5000);
  };
  
  const stopSwipeAnimation = () => {
    if (swipeIndicator) {
      isIndicatorReady = false;
      
      // Indicator'ı tamamen gizle
      swipeIndicator.style.opacity = '0';
      setTimeout(() => {
        swipeIndicator.style.display = 'none';
      }, 300);
    }
  };
  
  const hideSwipeIndicator = () => {
    if (swipeIndicator) {
      isIndicatorReady = false;
      swipeIndicator.style.opacity = '0';
      setTimeout(() => {
        swipeIndicator.style.display = 'none';
      }, 300);
    }
  };
  
  const handleFirstInteraction = () => {
    stopSwipeAnimation();
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          showSwipeIndicator();
          setupEventListeners();
          
          // Auto-hide after configured duration
          const comparisonElement = container.closest('quick-comparison-table');
          const animationDuration = comparisonElement && comparisonElement.dataset.animationDuration ? 
            parseInt(comparisonElement.dataset.animationDuration) * 1000 : 5000;
          
          setTimeout(() => {
            stopSwipeAnimation(false);
          }, animationDuration);
        }, 500);
        
        observer.disconnect();
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '0px 0px -50px 0px'
  });
  
  observer.observe(table);
  
  const setupEventListeners = () => {
    const scrollHandler = () => {
      handleFirstInteraction();
      table.removeEventListener('scroll', scrollHandler);
    };
    
    const touchHandler = () => {
      handleFirstInteraction();
      container.removeEventListener('touchstart', touchHandler);
      container.removeEventListener('touchmove', touchHandler);
    };
    
    table.addEventListener('scroll', scrollHandler, { once: true, passive: true });
    container.addEventListener('touchstart', touchHandler, { once: true, passive: true });
    container.addEventListener('touchmove', touchHandler, { once: true, passive: true });
  };
  
  // Hide on window resize (orientation change)
  const resizeHandler = () => {
    if (window.innerWidth > 767) {
      hideSwipeIndicator(false);
    }
  };
  window.addEventListener('resize', resizeHandler, { once: true });
  
}

function initSwiperLogic(container) {
  if (!container) return;
  
  const table = container.querySelector('table.quick-comparison-table');
  if (!table) {
    // Retry until table is loaded
    let retryCount = 0;
    const maxRetries = 20;
    
    const checkForTable = () => {
      retryCount++;
      const newTable = container.querySelector('table.quick-comparison-table');
      if (newTable) {
        setTimeout(() => initSwiper(container), 50);
      } else if (retryCount < maxRetries) {
        setTimeout(checkForTable, 100);
      }
    };
    
    setTimeout(checkForTable, 100);
    return;
  }

  const prevBtn = container.querySelector('.swiper-button-prev');
  const nextBtn = container.querySelector('.swiper-button-next');
  const progressFill = container.querySelector('.swiper-pagination-progressbar-fill');
  
  if (!prevBtn || !nextBtn || !progressFill) return;

  if (!container.offsetWidth || !table.scrollWidth) {
    setTimeout(() => initSwiper(container), 100);
    return;
  }

  const getScrollableCells = () => {
    const rows = table.querySelectorAll('tr');
    const scrollableCells = [];
    
    rows.forEach(row => {
      const cells = row.querySelectorAll('th, td');
      for (let i = 2; i < cells.length; i++) { // Start from 3rd column (index 2)
        scrollableCells.push(cells[i]);
      }
    });
    
    return scrollableCells;
  };

  const scrollableCells = getScrollableCells();
  
  if (scrollableCells.length === 0) return;

  // Calculate fixed columns width (row labels + main product)
  const firstRow = table.querySelector('tr');
  if (!firstRow) return;
  
  const firstCell = firstRow.querySelector('th, td');
  const secondCell = firstRow.querySelector('th:nth-child(2), td:nth-child(2)');
  
  if (!firstCell || !secondCell) return;
  
  const fixedWidth = firstCell.offsetWidth + secondCell.offsetWidth;
    
  const getColumnCount = () => {
    const firstRow = table.querySelector('tr');
    if (!firstRow) return 0;
    const cells = firstRow.querySelectorAll('th, td');
    // Just count all columns beyond the first 2 (label + main product)
    return Math.max(0, cells.length - 2);
  };

  const getVisibleColumnsOnScreen = () => {
    if (totalColumns === 0) return 0;
    const singleColumnWidth = getSingleColumnWidth();
    if (singleColumnWidth === 0) return totalColumns;
    const currentVisibleWidth = Math.max(0, visibleScrollableWidth);
    
    // Son sütun için özel hesaplama (hem mobil hem desktop)
    const visibleColumns = Math.floor(currentVisibleWidth / singleColumnWidth);
    return Math.max(1, visibleColumns); // En az 1 sütun göster
  };
  
  const totalColumns = getColumnCount();
  
  // If there are no columns or only 1 column, disable navigation and return
  if (totalColumns <= 1) {
    prevBtn.disabled = true;
    nextBtn.disabled = true;
    prevBtn.classList.add('swiper-button-disabled');
    nextBtn.classList.add('swiper-button-disabled');
    prevBtn.setAttribute('aria-disabled', 'true');
    nextBtn.setAttribute('aria-disabled', 'true');
    prevBtn.setAttribute('tabindex', '-1');
    nextBtn.setAttribute('tabindex', '-1');
    progressFill.style.transform = `translate3d(0, 0, 0) scaleX(0) scaleY(1)`;
    return;
  }
  
  // Calculate scrollable area
  const containerWidth = container.offsetWidth;
  const tableWidth = table.scrollWidth;
  const scrollableWidth = tableWidth - fixedWidth;
  let visibleScrollableWidth = containerWidth - fixedWidth;
  
  // Son sütun için ekstra padding hesapla (hem mobil hem desktop)
  visibleScrollableWidth = Math.max(0, visibleScrollableWidth - 32); // 2rem ekstra margin
  
  const getSingleColumnWidth = () => {
    if (totalColumns === 0) return 0;
    return scrollableWidth / totalColumns;
  };
  
  let currentScroll = 0;
  let currentColumnIndex = 0;
  let maxScroll = Math.max(0, scrollableWidth - visibleScrollableWidth);
  let isAnimating = false;

  const realScrollableWidth = tableWidth - fixedWidth;
  const realVisibleWidth = containerWidth - fixedWidth;
  
  if (realScrollableWidth <= realVisibleWidth + 10 || scrollableWidth <= 0) { // 10px tolerance
    prevBtn.disabled = true;
    nextBtn.disabled = true;
    prevBtn.classList.add('swiper-button-disabled');
    nextBtn.classList.add('swiper-button-disabled');
    prevBtn.setAttribute('aria-disabled', 'true');
    nextBtn.setAttribute('aria-disabled', 'true');
    prevBtn.setAttribute('tabindex', '-1');
    nextBtn.setAttribute('tabindex', '-1');
    progressFill.style.transform = `translate3d(0, 0, 0) scaleX(0) scaleY(1)`;
    return;
  }

  function updateUI() {
    let atStart, atEnd, progress;
    
    if (totalColumns <= 1) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      prevBtn.classList.add('swiper-button-disabled');
      nextBtn.classList.add('swiper-button-disabled');
      prevBtn.setAttribute('aria-disabled', 'true');
      nextBtn.setAttribute('aria-disabled', 'true');
      prevBtn.setAttribute('tabindex', '-1');
      nextBtn.setAttribute('tabindex', '-1');
      progressFill.style.transform = `translate3d(0, 0, 0) scaleX(0) scaleY(1)`;
      return;
    }
    
    const containerWidth = container.offsetWidth;
    const tableWidth = table.scrollWidth;
    const realScrollableWidth = tableWidth - fixedWidth;
    const realVisibleWidth = containerWidth - fixedWidth;
    
    if (realScrollableWidth <= realVisibleWidth + 10) { // 10px tolerance
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      prevBtn.classList.add('swiper-button-disabled');
      nextBtn.classList.add('swiper-button-disabled');
      prevBtn.setAttribute('aria-disabled', 'true');
      nextBtn.setAttribute('aria-disabled', 'true');
      prevBtn.setAttribute('tabindex', '-1');
      nextBtn.setAttribute('tabindex', '-1');
      progressFill.style.transform = `translate3d(0, 0, 0) scaleX(0) scaleY(1)`;
      return;
    }
    
    const visibleColumns = getVisibleColumnsOnScreen();
    const maxColumnIndex = Math.max(0, totalColumns - visibleColumns);
    
    atStart = currentColumnIndex <= 0;
    atEnd = currentColumnIndex >= maxColumnIndex;
    progress = maxColumnIndex > 0 ? (currentColumnIndex / maxColumnIndex) * 100 : 0;
    
    const singleColumnWidth = getSingleColumnWidth();
    currentScroll = Math.min(currentColumnIndex * singleColumnWidth, maxScroll);
    
    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
    
    if (atStart) {
      prevBtn.classList.add('swiper-button-disabled');
      prevBtn.setAttribute('aria-disabled', 'true');
      prevBtn.setAttribute('tabindex', '-1');
    } else {
      prevBtn.classList.remove('swiper-button-disabled');
      prevBtn.setAttribute('aria-disabled', 'false');
      prevBtn.setAttribute('tabindex', '0');
    }
    
    if (atEnd) {
      nextBtn.classList.add('swiper-button-disabled');
      nextBtn.setAttribute('aria-disabled', 'true');
      nextBtn.setAttribute('tabindex', '-1');
    } else {
      nextBtn.classList.remove('swiper-button-disabled');
      nextBtn.setAttribute('aria-disabled', 'false');
      nextBtn.setAttribute('tabindex', '0');
    }
    
    progressFill.style.transform = `translate3d(0, 0, 0) scaleX(${progress / 100}) scaleY(1)`;
    
    scrollableCells.forEach(cell => {
      cell.style.transform = `translateX(-${currentScroll}px)`;
      cell.style.transition = 'transform 0.3s ease';
    });
  }
  
  function scrollToColumn(columnIndex) {
    if (isAnimating || totalColumns <= 1) return;
    
    const visibleColumns = getVisibleColumnsOnScreen();
    const maxColumnIndex = Math.max(0, totalColumns - visibleColumns);
    
    if (visibleColumns >= totalColumns || maxColumnIndex <= 0) return;
    
    isAnimating = true;
    currentColumnIndex = Math.max(0, Math.min(columnIndex, maxColumnIndex));
    
    updateUI();
    
    setTimeout(() => {
      isAnimating = false;
    }, 300);
  }

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (prevBtn.disabled || isAnimating) return;
    scrollToColumn(currentColumnIndex - 1);
  });

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (nextBtn.disabled || isAnimating) return;
    scrollToColumn(currentColumnIndex + 1);
  });

  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let initialScroll = 0;
  let startTime = 0;
  let allowTouch = true;

  function handleStart(e) {
    if (isAnimating || !allowTouch) return;
    
    isDragging = true;
    startTime = Date.now();
    
    if (e.type === 'touchstart') {
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    } else if (e.type === 'mousedown') {
      startX = e.clientX;
      startY = e.clientY;
      e.preventDefault(); // Prevent text selection
    }
    
    initialScroll = currentScroll;
    
    scrollableCells.forEach(cell => {
      cell.style.transition = 'none';
    });
  }

  function handleMove(e) {
    if (!isDragging || isAnimating || !allowTouch) return;
    
    let currentX, currentY;
    
    if (e.type === 'touchmove') {
      const touch = e.touches[0];
      currentX = touch.clientX || touch.pageX;
      currentY = touch.clientY || touch.pageY;
      
      // Eski iOS için son pozisyonu kaydet
      window.lastTouchX = currentX;
      window.lastTouchY = currentY;
    } else if (e.type === 'mousemove') {
      currentX = e.clientX;
      currentY = e.clientY;
    }
    
    const deltaX = startX - currentX;
    const deltaY = startY - currentY;
    
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
      e.preventDefault();
    }
  }

  function handleEnd(e) {
    if (!isDragging || !allowTouch) return;
    
    isDragging = false;
    
    let endX, endY;
    
    if (e.type === 'touchend') {
      // Eski iOS için fallback - eğer changedTouches boşsa son kaydedilen pozisyonu kullan
      if (e.changedTouches && e.changedTouches.length > 0) {
        const touch = e.changedTouches[0];
        endX = touch.clientX || touch.pageX;
        endY = touch.clientY || touch.pageY;
      } else {
        // Fallback: son move'daki pozisyonu kullan
        endX = window.lastTouchX || startX;
        endY = window.lastTouchY || startY;
      }
    } else if (e.type === 'mouseup') {
      endX = e.clientX;
      endY = e.clientY;
    }
    
    const deltaX = startX - endX;
    const deltaY = startY - endY;
    const dragDuration = Date.now() - startTime;
    
    scrollableCells.forEach(cell => {
      cell.style.transition = 'transform 0.3s ease';
    });
    
    // Eski iOS için daha toleranslı threshold
    const minSwipeDistance = 30;
    const maxSwipeTime = 800; // Daha uzun süre
    
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance && dragDuration < maxSwipeTime) {
      if (deltaX < 0) {
        scrollToColumn(currentColumnIndex - 1);
      } else {
        scrollToColumn(currentColumnIndex + 1);
      }
    } else {
      updateUI();
    }
    
    // Cleanup
    window.lastTouchX = undefined;
    window.lastTouchY = undefined;
  }

  container.addEventListener('touchstart', handleStart, { passive: false });
  container.addEventListener('touchmove', handleMove, { passive: false });
  container.addEventListener('touchend', handleEnd, { passive: false });
  
  container.addEventListener('mousedown', handleStart);
  container.addEventListener('mousemove', handleMove);
  container.addEventListener('mouseup', handleEnd);
  
  container.addEventListener('contextmenu', (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  });

  let resizeTimer;
  let lastContainerWidth = container.offsetWidth;
  
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const newContainerWidth = container.offsetWidth;
      const newTableWidth = table.scrollWidth;
      const newScrollableWidth = newTableWidth - fixedWidth;
      let newVisibleScrollableWidth = newContainerWidth - fixedWidth;
      
      // Son sütun için ekstra padding hesapla (hem mobil hem desktop)
      newVisibleScrollableWidth = Math.max(0, newVisibleScrollableWidth - 32); // 2rem ekstra margin
      
      maxScroll = Math.max(0, newScrollableWidth - newVisibleScrollableWidth);
      visibleScrollableWidth = newVisibleScrollableWidth;
      
      // Sadece gerçek resize durumunda (genişlik değiştiyse) sıfırla
      if (Math.abs(newContainerWidth - lastContainerWidth) > 10) {
        currentColumnIndex = 0;
        lastContainerWidth = newContainerWidth;
      }
      
      updateUI();
    }, 250);
  }
  
  window.addEventListener('resize', handleResize);
  
  currentColumnIndex = 0;
  updateUI();
  
  handleResize();
}

document.addEventListener('DOMContentLoaded', () => {
  const tables = document.querySelectorAll('quick-comparison-table');
  
  tables.forEach(table => {
    if (!table) return;
    
    if (!table.hasAttribute('data-initialized')) {
      table.dispatchEvent(new Event('load'));
    } else {
      setTimeout(() => {
        const tableContainer = table.querySelector('.quick-comparison-table-container');
        if (tableContainer) {
          initSwiper(tableContainer);
        }
      }, 50);
    }
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return;
  
  const tables = event.target.querySelectorAll('quick-comparison-table');
  tables.forEach(table => {
    if (!table) return;
    
    if (table.refresh) {
      table.refresh();
    } else {
      setTimeout(() => {
        const tableContainer = table.querySelector('.quick-comparison-table-container');
        if (tableContainer) {
          initSwiper(tableContainer);
        }
      }, 100);
    }
  });
});

window.refreshComparisonTables = function() {
  const tables = document.querySelectorAll('quick-comparison-table');
  
  tables.forEach(table => {
    if (!table) return;
    
    if (table.refresh) {
      table.refresh();
    } else {
      setTimeout(() => {
        const tableContainer = table.querySelector('.quick-comparison-table-container');
        if (tableContainer) {
          initSwiper(tableContainer);
        }
      }, 100);
    }
  });
};
